import { render, staticRenderFns } from "./wf-radio-button-list-with-other-display.vue?vue&type=template&id=961c361e&scoped=true&"
import script from "./wf-radio-button-list-with-other-display.vue?vue&type=script&lang=ts&"
export * from "./wf-radio-button-list-with-other-display.vue?vue&type=script&lang=ts&"
import style0 from "./wf-radio-button-list-with-other-display.vue?vue&type=style&index=0&id=961c361e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961c361e",
  null
  
)

export default component.exports